define('OutSystems/ReactWidgets/ListItemAction',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ListItemAction = void 0;
    var ListItemAction = (function (_super) {
        tslib_1.__extends(ListItemAction, _super);
        function ListItemAction(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.disableSpamProtect = _this.disableSpamProtection(props);
            return _this;
        }
        ListItemAction.prototype.handleClick = function (event) {
            var _this = this;
            if (!this.alreadyTriggered || this.disableSpamProtect) {
                this.executeWithActiveClassOn(function () { return _this.props.onClick(); });
                this.alreadyTriggered = true;
            }
        };
        ListItemAction.prototype.render = function () {
            var _this = this;
            var listItemActionAttributes = {
                "data-list-item-action": "",
                className: this.props.style,
                onClick: function (event) { return _this.handleClick(event); },
            };
            this.fillWithBuiltinProperties(listItemActionAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.button, listItemActionAttributes, this.props.children);
        };
        ListItemAction.prototype.disableSpamProtection = function (props) {
            return (!!props.extendedProperties &&
                (props.extendedProperties["disable-spam-protection"] + "").toLowerCase() !== "true");
        };
        ListItemAction = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], ListItemAction);
        return ListItemAction;
    }(Widget_1.Widget));
    exports.ListItemAction = ListItemAction;
});
//# sourceMappingURL=ListItemAction.js.map;
